export default [
  {
    path: "/source",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "source_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          title: "Fontes",
          breadcrumbs: [
            { label: "Fontes", to: "source_list" }
          ],
          permission: "source:show"
        }
      },
      {
        name: "source_show",
        path: "show/:id",
        component: () => import("./pages/Show"),
        meta: {
          title: "Fontes | Visualizar",
          breadcrumbs: [
            { label: "Fontes", to: "source_list" },
            { label: "Visualizar", to: "source_show" }
          ],
          permission: "source:show"
        }
      },
      {
        name: "source_create",
        path: "create",
        component: () => import("./pages/Create"),
        meta: {
          title: "Fontes | Cadastro",
          breadcrumbs: [
            { label: "Fontes", to: "source_list" },
            { label: "Novo", to: "source_create" }
          ],
          permission: "source:create"
        }
      },
      {
        name: "source_edit",
        path: "edit/:id",
        component: () => import("./pages/Edit"),
        meta: {
          title: "Fontes | Edição",
          breadcrumbs: [
            { label: "Fontes", to: "source_list" },
            { label: "Editar", to: "source_edit" }
          ],
          permission: "source:edit"
        }
      }
    ]
  }
];
